<div fxLayout="row wrap" fxLayoutAlign="space-around center" fxLayoutGap="15px grid" style="padding: 10px">
  <div fxFlex="100">
    <abcInput
      #designationInput
      [style]="4"
      [id]="'Designation'"
      [value]="''"
      [placeholder]="res('DocumentsEditorCardDetails-Designation')"
      [width]="'100%'"
      [height]="'40px'"
    ></abcInput>
  </div>
  <div fxFlex="67">
    <abcCombobox
      #documentKindCombobox
      [label]="res('DocumentsEditorCardDetails-DocumentKind')"
      [placeholder]="res('DocumentsEditorCardDetails-DocumentKind')"
      [id]="'Kind'"
      [style]="4"
      (click)="openDocumentKind()"
      [showColumnHeader]="false"
    >
    </abcCombobox>
  </div>
  <div fxFlex="33">
    <abcDatepicker
      #dateInput
      [id]="'Date'"
      [style]="4"
      [placeholder]="res('DocumentsEditorCardDetails-Date')"
      [width]="'100%'"
      [height]="'40px'"
    >
    </abcDatepicker>
  </div>
  <div fxFlex="90">
    <abcInput
      #fileNameUploader
      [style]="4"
      [width]="'100%'"
      [id]="'FileName'"
      [placeholder]="res('DocumentsEditorCardDetails-Filename')"
    >
    </abcInput>
  </div>
  <div fxFlex="">
    <abcFileUploader
      [style]="4"
      [id]="'FileUploader'"
      [width]="'100%'"
      [height]="'100%'"
      (onFileUploaded)="uploadFileData($event)"
    >
    </abcFileUploader>
  </div>
</div>
<div
  fxLayout="row wrap"
  fxLayoutAlign="space-around center"
  fxLayoutGap="15px grid"
  style="padding: 10px"
  [ngStyle]="{ display: displayDetailsFields ? 'flex' : 'none' }"
>
  <div fxFlex="33">
    <abcCombobox
      #dataCarrierCombobox
      [id]="'DataCarrier'"
      [style]="4"
      [label]="res('DocumentsEditorCardDetails-DataCarrier')"
      [placeholder]="res('DocumentsEditorCardDetails-DataCarrier')"
      (click)="openDocumentCarrier()"
    ></abcCombobox>
  </div>
  <div fxFlex="">
    <abcInput
      #numberInput
      [id]="'Number'"
      [type]="'number'"
      [style]="4"
      [placeholder]="res('DocumentsEditorCardDetails-Number')"
      [width]="'100%'"
      [height]="'40px'"
    >
    </abcInput>
  </div>
  <div fxFlex="100">
    <abcInput
      #programPathInput
      [id]="'ProgramPath'"
      [style]="4"
      [placeholder]="res('DocumentsEditorCardDetails-ProgramPath')"
      [width]="'100%'"
      [height]="'40px'"
    ></abcInput>
  </div>
  <div fxFlex="33">
    <abcDatepicker
      #validFromInput
      [id]="'ValidFrom'"
      [style]="4"
      [placeholder]="res('DocumentsEditorCardDetails-ValidFrom')"
      [width]="'100%'"
      [height]="'40px'"
    ></abcDatepicker>
  </div>
  <div fxFlex="33">
    <abcDatepicker
      #validUntilInput
      [id]="'ValidUntil'"
      [style]="4"
      [placeholder]="res('DocumentsEditorCardDetails-ValidUntil')"
      [width]="'100%'"
      [height]="'40px'"
    ></abcDatepicker>
  </div>
  <div fxFlex=""></div>
  <div fxFlex="100">
    <abcTextArea
      #Comment
      [id]="'Comment'"
      [width]="'100%'"
      [height]="'111px'"
      [placeholder]="res('DocumentsEditorCardDetails-Comment')"
    >
    </abcTextArea>
  </div>

  <div fxFlex="50">
    <label *ngIf="document?.InsertDate">{{ res('DocumentsEditorCardDetails-InsertedOn') }}: </label>
    <span>{{ document?.InsertDate }}</span>
  </div>
  <div fxFlex="50">
    <label *ngIf="document?.UpdateDate">{{ res('DocumentsEditorCardDetails-LastUpdateOn') }}: </label>
    <span>{{ document?.UpdateDate }}</span>
  </div>
</div>

<div fxLayout="row" fxLayoutGap="10px" class="docActionButtons" fxLayoutAlign="end center">
  <abcButton
    *ngIf="displayDetailsFields"
    [id]="'button-Reset'"
    [style]="4"
    [width]="'120px'"
    [height]="'30px'"
    [value]="res('DocumentsEditorCardDetails-Reset')"
    (click)="resetButton()"
  >
  </abcButton>
  <abcButton
    [id]="'button-Ok'"
    [style]="4"
    [width]="'120px'"
    [height]="'30px'"
    [value]="res('DocumentsEditorCardDetails-Ok')"
    (click)="okButton()"
    [disabled]="isOkBtnDisabled"
  >
  </abcButton>
  <abcButton
    [id]="'button-Cancel'"
    [style]="4"
    [width]="'120px'"
    [height]="'30px'"
    [value]="res('DocumentsEditorCardDetails-Cancel')"
    (click)="cancelButton()"
  >
  </abcButton>
</div>
